module.exports = __webpack_public_path__ + "static/media/CardStatement.36c32c5d.svg";